import { call } from '../http-client'

const sendTroubleshootingInfo = async (troubleshootingInfo,kind='TROUBLESHOUTING') => {
    try {
        return await call('POST', '', 'troubleshoot', { kind, troubleshootingInfo })
    } catch{
        return;
    }
}

export { sendTroubleshootingInfo }
